export const brand = {
  name: {
    full: 'SANFORDEV Consulting',
    short: 'SANFORDEV',
    prefix: 'SANFOR',
    suffix: 'DEV',
  },
  images: {
    logo: 'emblem',
    sizes: {
      sm: { width: 40, height: 40 },
      md: { width: 48, height: 48 },
      lg: { width: 56, height: 56 },
      xl: { width: 300, height: 300 },
    },
  },
} as const;
